import React from 'react';
import './apps-view.css';
import alertIcon from './alert-icon.svg';
import App from './App';
import Hero from 'components/Hero';
import Switch from 'components/Switch';
import CLModal from '../../components/CLModal';
import { connect } from 'react-redux';

const AppsView = (props) => {
    return(
        <div className="apps-page">
            <Hero onSearch={props.onSearch} search={props.search} onClearSearch={props.onClearSearch}/>
            <div className="clwww-integration-apps">
                <div className="integration-apps-container">
                    <div className="integration-categories-container">
                        <h4>Categories</h4>
                        {props.tags.map((tag,i) => <p onClick={()=>props.onSelectCategory(tag.name)} className={`category left ${props.category===tag.name ? 'selected': ''}`} key={`${tag.name}-${i}`}>{tag.name}</p>)}
                    </div>
                    <div className="integrations-container">
                        <div className="integration-apps-header">
                            <h4 id="category-text">{props.category}</h4>
                            {props.authenticated ? 
                                <div className="apps-installed">
                                    {props.hasIntegrationErrors ? <img className="integration-error" src={alertIcon}/> : null}
                                    <p>Installed</p>
                                    <Switch onChange={props.onToggleInstalled} checked={props.showInstalled}/>
                                </div> : null}
                        </div>
                        <div className="integration-apps">
                            {props.apps.length ? 
                                props.apps.map(app=>{
                                    return <App 
                                                key={app.ID}
                                                app={app}
                                                onResetApp={props.onResetApp}
                                                onToggleConfigure={props.onToggleConfigure}
                                                onUninstallApp={props.onUninstallApp}
                                                onInstallApp={props.onInstallApp}
                                                onToggleRequireApiKey={props.onToggleRequireApiKey}
                                                authenticated={props.authenticated}
                                                integrations={props.integrations}/>
                                }) 
                            : <div className="no-results"><p>No results</p></div>}
                        </div>
                    </div>
                </div>
            </div>
            {props.form === 'configure' ? <CLModal appID={props.appID} form={props.form} isOpen={props.form === 'configure'}/> : null}
            {props.form === 'install' ? <CLModal appID={props.appID} form={props.form} isOpen={props.form === 'install'}/> : null}
        </div>
    )
}

const mapStateToProps = state => {
    return {
        form: state.ui.form,
        appID: state.ui.appID,
    }
}

export default connect(mapStateToProps)(AppsView);


// WEBPACK FOOTER //
// ./src/scenes/Apps/AppsView.js